import ApiService from "service/Api";
import { WarrantyPayloadTypes } from "utilities/types/Warranty";

const WarrantyService = {
  getAllWarranties: async (
    page: number,
    search: string,
    limit: number,
    filterTenant: number
  ) => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      params: {
        search: search,
        page: page,
        per_page: limit,
        filter_tenant: filterTenant,
      },
      url: "/admin/warranties",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateWarranty: async (warrantyId: string, payload: WarrantyPayloadTypes) => {
    const { isApproved, warrantyExpiry, tenantId } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        is_approved: isApproved,
        warranty_expiry: warrantyExpiry,
        tenant_id: tenantId,
        _method: "PUT",
      },
      url: "/admin/warranties/" + warrantyId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteWarranty: async (warrantyId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/warranties/" + warrantyId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default WarrantyService;
